module.exports = __webpack_public_path__ + "andre_bolini--63409b94.jpg";


//////////////////
// WEBPACK FOOTER
// ./_source/img/candidatos/andre_bolini.jpg
// module id = 156
// module chunks = 0